import { render } from "./SearchFullItem.vue?vue&type=template&id=825df0a4&scoped=true"
import script from "./SearchFullItem.vue?vue&type=script&lang=js"
export * from "./SearchFullItem.vue?vue&type=script&lang=js"

import "./SearchFullItem.vue?vue&type=style&index=0&id=825df0a4&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-825df0a4"]])

export default __exports__